<template>
  <b-form-group>
    <b-form-checkbox
      name="qualificacao_proposta_checkbox"
      v-model="localValue"
      v-for="(proposta, key) in qualificacao_proposta"
      :key="key"
      :value="proposta.value"
      stacked
    >
      {{ proposta.text }}

      <div
        v-if="proposta.children && propostaSelecionada(proposta.value)"
        class="my-4"
      >
        <h4>{{ proposta.children_text }}</h4>
        <b-form-radio-group
          name="qualificacao_proposta_radio"
          v-model="localEmenda"
          :options="proposta.children"
          stacked
        />
      </div>
    </b-form-checkbox>
  </b-form-group>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SelectQualificacaoPropostas",
  props: {
    value: Array,
    emenda: String,
  },
  computed: {
    ...mapGetters("oportunidades", ["qualificacao_proposta"]),
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    localEmenda: {
      get() {
        return this.emenda;
      },
      set(val) {
        this.$emit("update:emenda", val);
      },
    },
  },
  methods: {
    propostaSelecionada(value) {
      return this.localValue?.includes(value);
    },
  },
};
</script>
